<template>
  <div class="login-view">
    <div class="login-view__container">
      <div class="login-view__header">
        <h1 class="login-view__title">Welcome Back</h1>
        <p class="login-view__subtitle">
          Sign in to continue your writing journey
        </p>
      </div>

      <LoginForm />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import LoginForm from '@/components/auth/LoginForm.vue';

const router = useRouter();
const authStore = useAuthStore();

// Redirect if already authenticated
onMounted(() => {
  if (authStore.isAuthenticated) {
    router.replace('/dashboard');
  }
});
</script>

<style scoped>
.login-view {
  min-height: calc(100vh - 72px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-2xl) var(--space-lg);
  background: var(--color-bg-secondary);
}

.login-view__container {
  width: 100%;
  max-width: 500px;
}

.login-view__header {
  text-align: center;
  margin-bottom: var(--space-2xl);
}

.login-view__title {
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin: 0 0 var(--space-sm) 0;
}

.login-view__subtitle {
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
  margin: 0;
  line-height: var(--line-height-relaxed);
}

/* Responsive Design */
@media (max-width: 768px) {
  .login-view {
    padding: var(--space-lg);
    min-height: calc(100vh - 64px);
  }

  .login-view__title {
    font-size: var(--font-size-2xl);
  }
}
</style>
